import { render } from "./VehicleHeader.vue?vue&type=template&id=53ba0baf&scoped=true"
import script from "./VehicleHeader.vue?vue&type=script&lang=js"
export * from "./VehicleHeader.vue?vue&type=script&lang=js"

import "./VehicleHeader.vue?vue&type=style&index=0&id=53ba0baf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ba0baf"]])

export default __exports__